export default {
    capsLock() {
        const fields = document.querySelectorAll('.no-caps-lock-form input[type="text"], .no-caps-lock-form input[type="search"], .no-caps-lock-form input[type="email"], .no-caps-lock-form input[type="tel"], .no-caps-lock-form input[type="url"], .no-caps-lock-form textarea');

        function isLetter(ch) {
            return ch && ch.length === 1 && /[A-Za-zÀ-ž]/.test(ch); // supports extended latin
        }

        function insertAtCursor(el, text) {
            const start = el.selectionStart, end = el.selectionEnd;
            const before = el.value.slice(0, start);
            const after  = el.value.slice(end);
            el.value = before + text + after;
            const pos = start + text.length;
            el.setSelectionRange(pos, pos);
            el.dispatchEvent(new Event('input', { bubbles: true })); // keep frameworks happy
        }

        fields.forEach(el => {
            // Neutralize CapsLock for typed letters
            el.addEventListener('keydown', e => {
            const caps = e.getModifierState && e.getModifierState('CapsLock');
            if (!caps) return;                // only intervene when CapsLock is ON
            if (e.metaKey || e.ctrlKey || e.altKey) return;
            if (!isLetter(e.key)) return;     // only letters

            // With CapsLock ON:
            // - Shift pressed => allow uppercase (user's intent)
            // - No Shift => force lowercase
            const ch = e.key;
            const out = e.shiftKey ? ch.toUpperCase() : ch.toLowerCase();

            // Prevent native insertion and insert our adjusted char
            e.preventDefault();
            insertAtCursor(el, out);
            });

            // Also normalize pasted text when CapsLock is ON (optional)
            el.addEventListener('paste', e => {
            const caps = e.getModifierState && e.getModifierState('CapsLock');
            if (!caps) return; // leave paste untouched if CapsLock off
            const text = (e.clipboardData || window.clipboardData).getData('text');
            if (!text) return;
            e.preventDefault();
            insertAtCursor(el, text.toLowerCase());
            });
        });
        
    },


    /**
     * Prevent symbols like * and / in input fields
     */
    preventSymbols() {
        const fields = document.querySelectorAll('.no-symbols-form input[type="text"], .no-symbols-form input[type="search"], .no-symbols-form input[type="email"], .no-symbols-form input[type="tel"], .no-symbols-form input[type="url"], .no-symbols-form textarea');

        fields.forEach(el => {
            // if input has class allow-symbols, don't prevent symbols
            if (el.classList.contains('allow-symbols')) {
                return;
            }

            el.addEventListener('keydown', e => {
                if (e.key === '*' || e.key === '/') {
                    e.preventDefault();
                }
            });
        });
    }

}